import React, { useContext, useState, useEffect } from "react";
import OperationAnnotationEventForm from "./OperationAnnotationEventForm";
import { DashboardContext } from 'live/context/dashboard'
import styled, { css } from 'styled-components'
import api from "../../api";
import TrippingAnnotationEventForm from "./TrippingAnnotationEventForm";
import DataQualityAnnotationEventForm from "./DataQualityAnnotationEventForm";
import { Header, __SOURCE_ILT__, __SOURCE_METADATA__ } from "../commom";
import ILTEditionAnnotationEventForm from "../ilt/ILTEditionAnnotationEventForm";
import RunComponentAnnotationEventForm from "./RunComponentAnnotationEventForm";
import CasingAnnotationEventForm from "./CasingAnnotationEventForm";
import ForceExclusionAnnotationEventForm from "./ForceExclusionAnnotationEventForm";
import KpiIndicatorAnnotationEventForm from "./KpiIndicatorAnnotationEventForm";

export const OPERATION_TYPE_KEY = 'operation_type'
export const RUN_COMPONENT_TYPE_KEY = 'run_component_type'
export const CASING_TYPE_KEY = 'casing_type'
export const DATA_QUALITY_TYPE_KEY = 'data_quality_type'
export const TRIPPING_TYPE_KEY = 'tripping_type'
export const FORCE_EXCLUSION_TYPE_KEY = 'force_exclusion_type'
export const KPI_INDICATOR_TYPE_KEY = 'kpi_indicator_type'

export const metadataOptionsKeyTitle = {
    [FORCE_EXCLUSION_TYPE_KEY]: 'FORCE EXCLUSION',
    // [OPERATION_TYPE_KEY]: 'OPERATION',
    // [DATA_QUALITY_TYPE_KEY]: 'DATA QUALITY',
    // [TRIPPING_TYPE_KEY]: 'TRIPPING TYPE',
    [RUN_COMPONENT_TYPE_KEY]: 'RUN COMPONENT',
    // [KPI_INDICATOR_TYPE_KEY]: 'KPI INDICATOR',
    // [CASING_TYPE_KEY]: 'CASING TYPE',
}

export const getMetadataComponent = (__src, metadata_type) => {
    // console.log('__src', __src, 'metadata_type', metadata_type)

    // if (metadata_type === KPI_INDICATOR_TYPE_KEY)
    //     return KpiIndicatorAnnotationEventForm

    if (metadata_type === FORCE_EXCLUSION_TYPE_KEY)
        return ForceExclusionAnnotationEventForm

    if (metadata_type === OPERATION_TYPE_KEY)
        return OperationAnnotationEventForm

    if (metadata_type === TRIPPING_TYPE_KEY)
        return TrippingAnnotationEventForm

    if (metadata_type === DATA_QUALITY_TYPE_KEY)
        return DataQualityAnnotationEventForm

    if (metadata_type == RUN_COMPONENT_TYPE_KEY)
        return RunComponentAnnotationEventForm

    if (metadata_type == CASING_TYPE_KEY)
        return CasingAnnotationEventForm

    if (__src === __SOURCE_ILT__)
        return ILTEditionAnnotationEventForm

    return null
}

export default function ({ mode, event, selectedComponent = undefined, ...props }) {
    if (mode !== 'temporal')
        return

    const [runPath, setRunPath] = useState({})
    const [interventionsTree, setInterventionsTree] = useState({})
    const [selected, setSelected] = useState(selectedComponent)
    const { state, params, ...context } = useContext(DashboardContext)
    const wellName = props.activeDashboardFilters?.asset_name_event_type ? props.activeDashboardFilters?.asset_name_event_type[0] : null

    useEffect(() => {
        // console.log('event', event)
        // console.log('props', props)
        // console.log(Object.keys(metadataOptionsKeyTitle))
    }, [JSON.stringify(event), JSON.stringify(props)])

    // useEffect(() => {
    //     console.log('selected', selected)
    // }, [selected])

    // useEffect(() => {
    //     if (selected !== undefined)
    //         props.onHide()

    //     const controller = new AbortController()
    //     const signal = controller.signal

    //     api.getInterventionsTree(signal, wellName).then(r => {
    //         if (r.ok) {
    //             return r.json()
    //         } else {
    //             return Promise.reject('Could not get interventions tree')
    //         }
    //     }).then(data => {
    //         console.log('InterventionsTree', data)
    //         setInterventionsTree(data)
    //     })

    //     api.getRunPath(signal, wellName, encodeURIComponent(`from ts ${event.begin} to ts ${event.begin}`)).then(r => {
    //         if (r.ok) {
    //             return r.json()
    //         } else {
    //             return Promise.reject('Could not find run path for this time interval')
    //         }
    //     }).then(data => {
    //         console.log('runPath', data)
    //         setRunPath(data)
    //     })
    // }, [JSON.stringify(params)])

    function onBack() {
        setSelected(null)
    }

    const Component = getMetadataComponent(event.__src, selected)

    return <MetadataContainerBody>
        {!!selected ? <Header title={metadataOptionsKeyTitle[selected]} onBack={onBack} /> : null}
        {!selected ?
            (<div className="timeline__notes-footer__forms-container">
                {Object.keys(metadataOptionsKeyTitle).map((key) => (
                <div key={key} className="timeline__notes-footer__form" onClick={() => setSelected(key)}>
                    {metadataOptionsKeyTitle[key]}
                </div>))}
            </div>) :
            (<Component onBack={onBack} event={event} onHide={props.onHide} {...props} />)
        }
    </MetadataContainerBody>
}

const MetadataContainerBody = styled.div`
    cursor: auto !important;

    .timeline_notes-header {
        display: flex;
        border-radius: 0px !important;
        background-color: var(--static-gray-900);

        .back {
            color: #c3e3fa;
            cursor: pointer;
            z-index: 2;
            padding-left: 5px;

            i {
                margin-right: 5px;
            }
        }

        .title {
            color: white;
            position: absolute;
            left: 0;
            right: 0;
        }
    }
`